export const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
export const TESTENGINE_API_BASE_URL =
  process.env.REACT_APP_TEST_ENGINE_BASE_URL;
export const SOURCE_VERISON = '1';
export const COMPANY_CODE = 'kananprep';
export const COMPANY_LOGO =
  'https://assets.kanan.co/logo/kanan-logo.svg';
